import api from "./api";

class ToursService {
  create(data) {
    
    return api.post("/tours/create", data);
  }
  getTourWithQuestion(params) {
    return api.post("/tours/get-rate", params);
  }
  saveQuestionTours(params) {
    return api.post("/tours/save-question", params);
  }
  getQuestionByCustomer(params) {
    return api.get("/tours/get-question-by-customer", { params });
  }
  updateQuestion(data) {
    return api.post("/tours/", data);
  }
  update(id,data) {

    return api.post("/tours/update/"+id, data);
  }
  updateInfo(data) {
    return api.patch("/user/info", data);
  }
  updatePassword(data) {
    return api.patch("/user/password", data);
  }

  getPublicContent() {
    return api.get("/test/all");
  }

  getUserBoard() {
    return api.get("/test/user");
  }

  getModeratorBoard() {
    return api.get("/test/mod");
  }

  getAdminBoard() {
    return api.get("/test/admin");
  }

  getDataPage(params) {
    return api.get("/tours/list", { params: params });
  }
  getList(params) {
    return this.getDataPage(params);
  }
  get(params) {
    return api.get("/tours/detail", { params: params });
  }
  destroys(ids) {
    return this.destroy(ids);
  }
  destroy(uri, data) {
    return api.delete(uri, data).then((response) => {
      return response;
    });
  }
}

export default new ToursService();
